import { render, staticRenderFns } from "./IntroPathwayView.vue?vue&type=template&id=985caf0e"
import script from "./IntroPathwayView.vue?vue&type=script&lang=js"
export * from "./IntroPathwayView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports